import React from 'react'
import Lottie from 'react-lottie';
import * as animationData from '@gifs/search_without_result.json'

function SearchWithoutResult() {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Lottie options={defaultOptions} isClickToPauseDisabled={true}/>
    )
}

export default React.memo(SearchWithoutResult);